import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Head from 'next/head';
import getMetaTagData from '../src/common/services/getMetaTagData';
import MainTop from '../src/component/pc/maintop/MainTop';
import MainBottom from '../src/component/pc/MainBottom/MainBottom';

function Platform({ metaTagData, jWTCheck }) {
  const sectionStyle = {
    backgroundImage: 'url(styles/2022/pc/img/platform_visual.png)'
  };

  // gtag
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'UA-104756746-1');
      gtag('config', 'G-L9E7Y63ZNE');
    }
  }, []);

  return (
    <>
      <script async src='https://www.googletagmanager.com/gtag/js?id=UA-104756746-1' />
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <meta name='description' content="SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!" />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={'' || ''} />
        <meta property='og:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={'' || ''} />
        <meta name='nate:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>플랫폼 소개 : SBS 소개 : SBS</title>
      </Head>

      <ul id='skip_nav'>
        <li><a href='#container'>본문컨텐츠</a></li>
        <li><a href='#header'>헤더 메뉴</a></li>
      </ul>

      <div id='wrap' className='sbsabout_wrap '>
        {/* <!-- 헤더 --> */}
        <MainTop />
        {/* <!-- 컨텐츠영역 --> */}
        <div id='container' className='contents'>
          <h2 className='hide'>SBS</h2>
          {/* <!-- 비쥬얼영역 --> */}
          <div className='sbsabout_visual_top_platform' style={sectionStyle}>
            <div className='sbsabout_inner'>
              <h3 className='sbsabout_visual_title'>플랫폼 소개</h3>
              <strong className='sbsabout_visual_info'>
                다양한 콘텐츠들을 가장 쉽고 편리하게 <br /> 즐길 수 있는 온라인 플랫폼을 소개합니다.
              </strong>
            </div>
          </div>
          {/* <!-- 컨텐츠 --> */}
          <div className='platform_contents_w'>
            <div className='sbsabout_inner'>
              {/* <!-- sbs web --> */}
              <div className='platform_w_website'>
                <div className='website_image_w'>
                  <img src='styles/2022/pc/img/service_01.png' alt='SBS 웹사이트 화면' className='website_image' />
                </div>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <h4 className='platform_title'>sbs.co.kr</h4>
                    <span className='platform_value'>WEBSITE</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      웰메이드 드라마, 새로운 웃음과 감동의 예능,<br />
                      시대 정신을 구현하는 교양, 한 단계 진화된 뉴스, 음악을 통해 교감하는 라디오까지!<br />
                      SBS 모든 프로그램의 가장 빠른 소식과 콘텐츠를 즐기다!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://www.sbs.co.kr/'>
                        <a className='platform_quick_link' aria-label='웹사이트'>
                          <span className='svg_icon_house'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <g data-name='Icon feather-home' transform='translate(-3 -1.5)'>
                                <path data-name='house_path 441' d='M19,1.5a1.361,1.361,0,0,1,.848.3L34.477,13.428A1.39,1.39,0,0,1,35,14.515V32.792A4.671,4.671,0,0,1,30.378,37.5H7.622A4.671,4.671,0,0,1,3,32.792V14.515a1.389,1.389,0,0,1,.523-1.088L18.152,1.8A1.361,1.361,0,0,1,19,1.5ZM32.257,15.187,19,4.647,5.743,15.187v17.6a1.912,1.912,0,0,0,1.879,1.938H30.378a1.912,1.912,0,0,0,1.879-1.938Z' transform='translate(0)' />
                                <path data-name='house_path 442' d='M22.5,34.5A1.5,1.5,0,0,1,21,33V19.5H15V33a1.5,1.5,0,0,1-3,0V18a1.5,1.5,0,0,1,1.5-1.5h9A1.5,1.5,0,0,1,24,18V33A1.5,1.5,0,0,1,22.5,34.5Z' transform='translate(1 3)' />
                              </g>
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- SBS App--> */}
              <div className='platform_w_app'>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <img src='styles/2022/pc/img/sbs_app_icon.png' alt='SBS앱 아이콘' className='platform_app_image' />
                    <h4 className='platform_title'>SBS</h4>
                    <span className='platform_value'>APP</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      SBS 실시간 콘텐츠를 가장 빠르게 한 번에 즐기는 방법!<br />
                      SBS 온에어, 인기 VOD, 8만편의 무료 VOD, 팟캐스트는<br /> 물론
                      다채로운 이벤트, 방청 신청과 입장까지 간편하게<br /> 한번에!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://play.google.com/store/apps/details?id=kr.co.sbs.videoplayer'>
                        <a className='platform_quick_link' aria-label='Google play'>
                          <span className='svg_icon_googleplay'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <path data-name='Icon awesome-google-play' d='M22.583,16.477,7.278.914,26.75,12.251l-4.168,4.227ZM3.284,0a2.738,2.738,0,0,0-1.5,2.483V33.517A2.738,2.738,0,0,0,3.284,36L21.078,18ZM32.77,15.866l-4.084-2.4L24.129,18l4.556,4.536,4.168-2.4a2.847,2.847,0,0,0-.083-4.276ZM7.278,35.093,26.75,23.756,22.583,19.53Z' transform='translate(-1.779)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                      <Link href='https://apps.apple.com/kr/app/sbs-%EC%98%A8%EC%97%90%EC%96%B4-%EC%A0%9C%EA%B3%B5-vod-7%EB%A7%8C%ED%8E%B8-%EC%A0%9C%EA%B3%B5/id1020136055'>
                        <a className='platform_quick_link' aria-label='App store'>
                          <span className='svg_icon_appstore'>
                            <svg width='36' height='36' viewBox='0 0 36 36'>
                              <path data-name='Icon awesome-app-store-ios' d='M32.143,2.25H3.857A3.858,3.858,0,0,0,0,6.107V34.393A3.858,3.858,0,0,0,3.857,38.25H32.143A3.858,3.858,0,0,0,36,34.393V6.107A3.858,3.858,0,0,0,32.143,2.25ZM10.205,30.576a1.606,1.606,0,0,1-2.78-1.607l1.149-1.985a2.758,2.758,0,0,1,3.182.916Zm11.162-4.331H6.75a1.607,1.607,0,0,1,0-3.214h4.1l5.255-9.1-1.647-2.845a1.606,1.606,0,1,1,2.78-1.607l.715,1.238.715-1.238a1.606,1.606,0,1,1,2.78,1.607L14.553,23.03h4.99a2.2,2.2,0,0,1,1.824,3.214Zm7.883,0H26.92l1.575,2.724a1.606,1.606,0,0,1-2.78,1.607q-3.966-6.858-5.946-10.294a4.446,4.446,0,0,1,.571-5.448q1.579,2.736,4.733,8.2H29.25a1.607,1.607,0,0,1,0,3.214Z' transform='translate(0 -2.25)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <!-- app 이미지 --> */}
                <div className='platform_service_w'>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_02_01.jpg' alt='SBS앱 메인 화면' />
                    </div>
                  </div>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_02_02.png' alt='SBS앱 라이브 페이지 화면' />
                    </div>
                  </div>
                </div>

              </div>

              {/* <!-- SBS 고릴라 --> */}
              <div className='platform_w_app'>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <img src='styles/2022/pc/img/goreala_app_icon.png' alt='SBS 고릴라 앱 아이콘' className='platform_app_image' />
                    <h4 className='platform_title'>SBS 고릴라</h4>
                    <span className='platform_value'>APP</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      언제어디서나 즐기는 라디오세상, SBS고릴라!<br />
                      SBS 파워FM  &amp; 러브FM 온에어, 24시간 전문 음악 채널 고릴라디오M, 팟캐스트, 보는라디오는 물론 공감로그를 통한 실시간 방송참여까지 라이브로 즐기다!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://play.google.com/store/apps/details?id=com.appgate.gorealra'>
                        <a className='platform_quick_link' aria-label='Google play'>
                          <span className='svg_icon_googleplay'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <path data-name='Icon awesome-google-play' d='M22.583,16.477,7.278.914,26.75,12.251l-4.168,4.227ZM3.284,0a2.738,2.738,0,0,0-1.5,2.483V33.517A2.738,2.738,0,0,0,3.284,36L21.078,18ZM32.77,15.866l-4.084-2.4L24.129,18l4.556,4.536,4.168-2.4a2.847,2.847,0,0,0-.083-4.276ZM7.278,35.093,26.75,23.756,22.583,19.53Z' transform='translate(-1.779)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                      <Link href='https://apps.apple.com/us/app/sbs-%EA%B3%A0%EB%A6%B4%EB%9D%BC/id406456433'>
                        <a className='platform_quick_link' aria-label='App store'>
                          <span className='svg_icon_appstore'>
                            <svg width='36' height='36' viewBox='0 0 36 36'>
                              <path data-name='Icon awesome-app-store-ios' d='M32.143,2.25H3.857A3.858,3.858,0,0,0,0,6.107V34.393A3.858,3.858,0,0,0,3.857,38.25H32.143A3.858,3.858,0,0,0,36,34.393V6.107A3.858,3.858,0,0,0,32.143,2.25ZM10.205,30.576a1.606,1.606,0,0,1-2.78-1.607l1.149-1.985a2.758,2.758,0,0,1,3.182.916Zm11.162-4.331H6.75a1.607,1.607,0,0,1,0-3.214h4.1l5.255-9.1-1.647-2.845a1.606,1.606,0,1,1,2.78-1.607l.715,1.238.715-1.238a1.606,1.606,0,1,1,2.78,1.607L14.553,23.03h4.99a2.2,2.2,0,0,1,1.824,3.214Zm7.883,0H26.92l1.575,2.724a1.606,1.606,0,0,1-2.78,1.607q-3.966-6.858-5.946-10.294a4.446,4.446,0,0,1,.571-5.448q1.579,2.736,4.733,8.2H29.25a1.607,1.607,0,0,1,0,3.214Z' transform='translate(0 -2.25)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <!-- app 이미지 --> */}
                <div className='platform_service_w'>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_03_01.png' alt='SBS 고릴라 앱 파워FM 탭 화면' />
                    </div>
                  </div>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_03_02.png' alt='SBS 고릴라 앱 러브FM 탭 화면' />
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- SBS News --> */}
              <div className='platform_w_app'>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <img src='styles/2022/pc/img/sbsnews_app_icon.png' alt='SBS 뉴스 앱 아이콘' className='platform_app_image' />
                    <h4 className='platform_title'>SBS NEWS</h4>
                    <span className='platform_value'>APP</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      대한민국 뉴스의 기준, 중심을 지키는 저널리즘 SBS 뉴스!<br />
                      생생한 취재 뒷이야기, 탐사보도, 데이터 저널리즘, 뉴스 스토리텔링, 오디오 뉴스, 24시 모바일 라이브 등을 통해 품격 있는 뉴스를 쉽고 빠르게 만나다!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://play.google.com/store/apps/details?id=com.cubeflux.news&hl=ko&gl=US'>
                        <a className='platform_quick_link' aria-label='Google play'>
                          <span className='svg_icon_googleplay'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <path data-name='Icon awesome-google-play' d='M22.583,16.477,7.278.914,26.75,12.251l-4.168,4.227ZM3.284,0a2.738,2.738,0,0,0-1.5,2.483V33.517A2.738,2.738,0,0,0,3.284,36L21.078,18ZM32.77,15.866l-4.084-2.4L24.129,18l4.556,4.536,4.168-2.4a2.847,2.847,0,0,0-.083-4.276ZM7.278,35.093,26.75,23.756,22.583,19.53Z' transform='translate(-1.779)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                      <Link href='https://apps.apple.com/kr/app/sbsnews/id371932445'>
                        <a className='platform_quick_link' aria-label='App store'>
                          <span className='svg_icon_appstore'>
                            <svg width='36' height='36' viewBox='0 0 36 36'>
                              <path data-name='Icon awesome-app-store-ios' d='M32.143,2.25H3.857A3.858,3.858,0,0,0,0,6.107V34.393A3.858,3.858,0,0,0,3.857,38.25H32.143A3.858,3.858,0,0,0,36,34.393V6.107A3.858,3.858,0,0,0,32.143,2.25ZM10.205,30.576a1.606,1.606,0,0,1-2.78-1.607l1.149-1.985a2.758,2.758,0,0,1,3.182.916Zm11.162-4.331H6.75a1.607,1.607,0,0,1,0-3.214h4.1l5.255-9.1-1.647-2.845a1.606,1.606,0,1,1,2.78-1.607l.715,1.238.715-1.238a1.606,1.606,0,1,1,2.78,1.607L14.553,23.03h4.99a2.2,2.2,0,0,1,1.824,3.214Zm7.883,0H26.92l1.575,2.724a1.606,1.606,0,0,1-2.78,1.607q-3.966-6.858-5.946-10.294a4.446,4.446,0,0,1,.571-5.448q1.579,2.736,4.733,8.2H29.25a1.607,1.607,0,0,1,0,3.214Z' transform='translate(0 -2.25)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <!-- app 이미지 --> */}
                <div className='platform_service_w'>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_04_01.png' alt='SBS 뉴스 앱 메인 화면' />
                    </div>
                  </div>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_04_02.png' alt='SBS 뉴스 앱 스브스뉴스 화면' />
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- SBS Golf --> */}
              <div className='platform_w_app'>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <img src='styles/2022/pc/img/sbsgolf_app_icon.png' alt='SBS 골프 앱 아이콘' className='platform_app_image' />
                    <h4 className='platform_title'>SBS 골프</h4>
                    <span className='platform_value'>APP</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      대한민국 골퍼들의 선택!<br /> 골프부문 독보적 1위 점유.<br />
                      골프의 모든 순간을 SBS골프닷컴과 함께 즐겨보세요.
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://play.google.com/store/apps/details?id=com.confitech.sbsgolf&hl=ko&gl=US'>
                        <a className='platform_quick_link' aria-label='Google play'>
                          <span className='svg_icon_googleplay'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <path data-name='Icon awesome-google-play' d='M22.583,16.477,7.278.914,26.75,12.251l-4.168,4.227ZM3.284,0a2.738,2.738,0,0,0-1.5,2.483V33.517A2.738,2.738,0,0,0,3.284,36L21.078,18ZM32.77,15.866l-4.084-2.4L24.129,18l4.556,4.536,4.168-2.4a2.847,2.847,0,0,0-.083-4.276ZM7.278,35.093,26.75,23.756,22.583,19.53Z' transform='translate(-1.779)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                      <Link href='https://apps.apple.com/kr/app/sbs%EA%B3%A8%ED%94%84/id450445233'>
                        <a className='platform_quick_link' aria-label='App store'>
                          <span className='svg_icon_appstore'>
                            <svg width='36' height='36' viewBox='0 0 36 36'>
                              <path data-name='Icon awesome-app-store-ios' d='M32.143,2.25H3.857A3.858,3.858,0,0,0,0,6.107V34.393A3.858,3.858,0,0,0,3.857,38.25H32.143A3.858,3.858,0,0,0,36,34.393V6.107A3.858,3.858,0,0,0,32.143,2.25ZM10.205,30.576a1.606,1.606,0,0,1-2.78-1.607l1.149-1.985a2.758,2.758,0,0,1,3.182.916Zm11.162-4.331H6.75a1.607,1.607,0,0,1,0-3.214h4.1l5.255-9.1-1.647-2.845a1.606,1.606,0,1,1,2.78-1.607l.715,1.238.715-1.238a1.606,1.606,0,1,1,2.78,1.607L14.553,23.03h4.99a2.2,2.2,0,0,1,1.824,3.214Zm7.883,0H26.92l1.575,2.724a1.606,1.606,0,0,1-2.78,1.607q-3.966-6.858-5.946-10.294a4.446,4.446,0,0,1,.571-5.448q1.579,2.736,4.733,8.2H29.25a1.607,1.607,0,0,1,0,3.214Z' transform='translate(0 -2.25)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <!-- app 이미지 --> */}
                <div className='platform_service_w'>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_05_01.png' alt='SBS 골프 앱 메인 화면' />
                    </div>
                  </div>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_05_02.png' alt='SBS 골프 앱 부킹 페이지 화면' />
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- SBS Biz --> */}
              <div className='platform_w_app'>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <img src='styles/2022/pc/img/sbsbiz_app_icon.png' alt='SBS Biz 앱 아이콘' className='platform_app_image' />
                    <h4 className='platform_title'>SBS Biz</h4>
                    <span className='platform_value'>APP</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      경제활동을 하는 사람들의 비즈니스를 담은 SBS Biz <br />
                      빠르고 정확하게 그리고 쉽게 이해할 수 있는 뉴스, 민생 경제와 일상에 활력을 불어넣고 우리 경제가 한단계 도약 할 수 있도록 함께 합니다!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://play.google.com/store/apps/details?id=kr.co.sbs.cnbc&hl=ko&gl=US'>
                        <a className='platform_quick_link' aria-label='Google play'>
                          <span className='svg_icon_googleplay'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <path data-name='Icon awesome-google-play' d='M22.583,16.477,7.278.914,26.75,12.251l-4.168,4.227ZM3.284,0a2.738,2.738,0,0,0-1.5,2.483V33.517A2.738,2.738,0,0,0,3.284,36L21.078,18ZM32.77,15.866l-4.084-2.4L24.129,18l4.556,4.536,4.168-2.4a2.847,2.847,0,0,0-.083-4.276ZM7.278,35.093,26.75,23.756,22.583,19.53Z' transform='translate(-1.779)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                      <Link href='https://apps.apple.com/kr/app/sbs-biz/id425106890'>
                        <a className='platform_quick_link' aria-label='App store'>
                          <span className='svg_icon_appstore'>
                            <svg width='36' height='36' viewBox='0 0 36 36'>
                              <path data-name='Icon awesome-app-store-ios' d='M32.143,2.25H3.857A3.858,3.858,0,0,0,0,6.107V34.393A3.858,3.858,0,0,0,3.857,38.25H32.143A3.858,3.858,0,0,0,36,34.393V6.107A3.858,3.858,0,0,0,32.143,2.25ZM10.205,30.576a1.606,1.606,0,0,1-2.78-1.607l1.149-1.985a2.758,2.758,0,0,1,3.182.916Zm11.162-4.331H6.75a1.607,1.607,0,0,1,0-3.214h4.1l5.255-9.1-1.647-2.845a1.606,1.606,0,1,1,2.78-1.607l.715,1.238.715-1.238a1.606,1.606,0,1,1,2.78,1.607L14.553,23.03h4.99a2.2,2.2,0,0,1,1.824,3.214Zm7.883,0H26.92l1.575,2.724a1.606,1.606,0,0,1-2.78,1.607q-3.966-6.858-5.946-10.294a4.446,4.446,0,0,1,.571-5.448q1.579,2.736,4.733,8.2H29.25a1.607,1.607,0,0,1,0,3.214Z' transform='translate(0 -2.25)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <!-- app 이미지 --> */}
                <div className='platform_service_w'>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_06_01.png' alt='SBS Biz 앱 메인 화면' />
                    </div>
                  </div>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_06_02.png' alt='SBS Biz 앱 온에어 페이지 화면' />
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- SBS 티팟 --> */}
              <div className='platform_w_app'>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <img src='styles/2022/pc/img/tpod_app_icon.png' alt='티팟 앱 아이콘' className='platform_app_image' />
                    <h4 className='platform_title'>티팟</h4>
                    <span className='platform_value'>APP</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      24시간 듣는 TV, 방송사들이 함께 만드는 차원이 다른 오디오 서비스 티팟! 드라마, 예능, 뉴스, 라디오, 종교방송, 실시간 뮤직채널까지~ 다양한 방송사들의 라이브 오디오와 팟캐스트를 티팟에서 간편하게 즐겨보세요!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://play.google.com/store/apps/details?id=kr.co.sbs.tpod&hl=ko&gl=US'>
                        <a className='platform_quick_link' aria-label='Google play'>
                          <span className='svg_icon_googleplay'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <path data-name='Icon awesome-google-play' d='M22.583,16.477,7.278.914,26.75,12.251l-4.168,4.227ZM3.284,0a2.738,2.738,0,0,0-1.5,2.483V33.517A2.738,2.738,0,0,0,3.284,36L21.078,18ZM32.77,15.866l-4.084-2.4L24.129,18l4.556,4.536,4.168-2.4a2.847,2.847,0,0,0-.083-4.276ZM7.278,35.093,26.75,23.756,22.583,19.53Z' transform='translate(-1.779)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                      <Link href='https://apps.apple.com/kr/app/%ED%8B%B0%ED%8C%9F-tpod/id1495146390'>
                        <a className='platform_quick_link' aria-label='App store'>
                          <span className='svg_icon_appstore'>
                            <svg width='36' height='36' viewBox='0 0 36 36'>
                              <path data-name='Icon awesome-app-store-ios' d='M32.143,2.25H3.857A3.858,3.858,0,0,0,0,6.107V34.393A3.858,3.858,0,0,0,3.857,38.25H32.143A3.858,3.858,0,0,0,36,34.393V6.107A3.858,3.858,0,0,0,32.143,2.25ZM10.205,30.576a1.606,1.606,0,0,1-2.78-1.607l1.149-1.985a2.758,2.758,0,0,1,3.182.916Zm11.162-4.331H6.75a1.607,1.607,0,0,1,0-3.214h4.1l5.255-9.1-1.647-2.845a1.606,1.606,0,1,1,2.78-1.607l.715,1.238.715-1.238a1.606,1.606,0,1,1,2.78,1.607L14.553,23.03h4.99a2.2,2.2,0,0,1,1.824,3.214Zm7.883,0H26.92l1.575,2.724a1.606,1.606,0,0,1-2.78,1.607q-3.966-6.858-5.946-10.294a4.446,4.446,0,0,1,.571-5.448q1.579,2.736,4.733,8.2H29.25a1.607,1.607,0,0,1,0,3.214Z' transform='translate(0 -2.25)' />
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <!-- app 이미지 --> */}
                <div className='platform_service_w'>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_07_01.png' alt='티팟 앱 메인 화면' />
                    </div>
                  </div>
                  <div className='platform_service_cont'>
                    <div className='ps_image_w'>
                      <img src='styles/2022/pc/img/service_07_02.png' alt='티팟 앱 플레이어 화면' />
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- AllVOD --> */}
              <div className='platform_w_website'>
                <div className='website_image_w'>
                  <img src='styles/2022/pc/img/service_08.png' alt='AllVOD 서비스 메인 화면' className='website_image' />
                </div>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <h4 className='platform_title'>AllVOD</h4>
                    <span className='platform_value'>WEBSITE</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      8만여편 SBS 레전드 구작 VOD는 물론 최신 인기 VOD까지!<br />
                      테마별, 이슈별, 스타별로 모아서 무료 정주행도 하고, <br />
                      나의 취향에 맞는 추천 VOD와 패키지할인까지 모두 즐기세요!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://allvod.sbs.co.kr/allvod/vodMain.do'>
                        <a className='platform_quick_link' aria-label='웹사이트'>
                          <span className='svg_icon_house'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <g data-name='Icon feather-home' transform='translate(-3 -1.5)'>
                                <path data-name='house_path 441' d='M19,1.5a1.361,1.361,0,0,1,.848.3L34.477,13.428A1.39,1.39,0,0,1,35,14.515V32.792A4.671,4.671,0,0,1,30.378,37.5H7.622A4.671,4.671,0,0,1,3,32.792V14.515a1.389,1.389,0,0,1,.523-1.088L18.152,1.8A1.361,1.361,0,0,1,19,1.5ZM32.257,15.187,19,4.647,5.743,15.187v17.6a1.912,1.912,0,0,0,1.879,1.938H30.378a1.912,1.912,0,0,0,1.879-1.938Z' transform='translate(0)' />
                                <path data-name='house_path 442' d='M22.5,34.5A1.5,1.5,0,0,1,21,33V19.5H15V33a1.5,1.5,0,0,1-3,0V18a1.5,1.5,0,0,1,1.5-1.5h9A1.5,1.5,0,0,1,24,18V33A1.5,1.5,0,0,1,22.5,34.5Z' transform='translate(1 3)' />
                              </g>
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- TV맛집 --> */}
              <div className='platform_w_website'>
                <div className='website_image_w'>
                  <img src='styles/2022/pc/img/service_09.png' alt='TV맛집 서비스 메인 화면' className='website_image' />
                </div>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <h4 className='platform_title'>TV맛집</h4>
                    <span className='platform_value'>WEBSITE</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      방송에 나온 맛집을 한 번에 모아서 볼 수 있는 TV맛집!<br />
                      생방송 투데이, 생활의 달인 등 관련 클립영상과 함께 맛집 정보를 확인해보세요~<br />
                      내 주변 가까운 맛집 추천은 물론 지역, 키워드별 맛집 정보 검색까지! TV맛집과 함께하는 맛있는 생활!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://matstar.sbs.co.kr/main.html'>
                        <a className='platform_quick_link' aria-label='웹사이트'>
                          <span className='svg_icon_house'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <g data-name='Icon feather-home' transform='translate(-3 -1.5)'>
                                <path data-name='house_path 441' d='M19,1.5a1.361,1.361,0,0,1,.848.3L34.477,13.428A1.39,1.39,0,0,1,35,14.515V32.792A4.671,4.671,0,0,1,30.378,37.5H7.622A4.671,4.671,0,0,1,3,32.792V14.515a1.389,1.389,0,0,1,.523-1.088L18.152,1.8A1.361,1.361,0,0,1,19,1.5ZM32.257,15.187,19,4.647,5.743,15.187v17.6a1.912,1.912,0,0,0,1.879,1.938H30.378a1.912,1.912,0,0,0,1.879-1.938Z' transform='translate(0)' />
                                <path data-name='house_path 442' d='M22.5,34.5A1.5,1.5,0,0,1,21,33V19.5H15V33a1.5,1.5,0,0,1-3,0V18a1.5,1.5,0,0,1,1.5-1.5h9A1.5,1.5,0,0,1,24,18V33A1.5,1.5,0,0,1,22.5,34.5Z' transform='translate(1 3)' />
                              </g>
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- 스타 --> */}
              <div className='platform_w_website'>
                <div className='website_image_w'>
                  <img src='styles/2022/pc/img/service_10.png' alt='STAR 서비스 메인 화면' className='website_image' />
                </div>
                <div className='platform_info_w'>
                  <div className='platform_title_w'>
                    <h4 className='platform_title'>STAR</h4>
                    <span className='platform_value'>WEBSITE</span>
                  </div>
                  <div className='platform_info_text_w'>
                    <p className='platform_info_text'>
                      내가 좋아하는 스타의 모든 것! SBS STAR!<br />
                      나의 스타의 SBS 출연 영상과 현장포토를 모아서 즐겨보세요~<br />
                      이 달의 스타로 선정되면 24시간 스타TV 오픈은 물론 다양한 혜택이 쏟아집니다!<br />
                      팬들과 함께 실시간으로 응원하고, 매일매일 쌓이는 포인트까지! 슬기로운 덕후 생활!
                    </p>
                    <div className='platform_quick_w'>
                      <strong className='platform_quick_title'>서비스 바로가기</strong>
                      <Link href='https://star.sbs.co.kr/'>
                        <a className='platform_quick_link' aria-label='웹사이트'>
                          <span className='svg_icon_house'>
                            <svg width='32' height='36' viewBox='0 0 32 36'>
                              <g data-name='Icon feather-home' transform='translate(-3 -1.5)'>
                                <path data-name='house_path 441' d='M19,1.5a1.361,1.361,0,0,1,.848.3L34.477,13.428A1.39,1.39,0,0,1,35,14.515V32.792A4.671,4.671,0,0,1,30.378,37.5H7.622A4.671,4.671,0,0,1,3,32.792V14.515a1.389,1.389,0,0,1,.523-1.088L18.152,1.8A1.361,1.361,0,0,1,19,1.5ZM32.257,15.187,19,4.647,5.743,15.187v17.6a1.912,1.912,0,0,0,1.879,1.938H30.378a1.912,1.912,0,0,0,1.879-1.938Z' transform='translate(0)' />
                                <path data-name='house_path 442' d='M22.5,34.5A1.5,1.5,0,0,1,21,33V19.5H15V33a1.5,1.5,0,0,1-3,0V18a1.5,1.5,0,0,1,1.5-1.5h9A1.5,1.5,0,0,1,24,18V33A1.5,1.5,0,0,1,22.5,34.5Z' transform='translate(1 3)' />
                              </g>
                            </svg>
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        {/* <!-- 풋터 --> */}
        <MainBottom />
      </div>

    </>
  );
}

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default Platform;
